import React, { useState, useRef, useEffect } from 'react';
const Tooltip = ({ children, content, isOnClick = false, wrapperClassName = '' }) => {
	const [open, setOpen] = useState(false);
	const rootRef = useRef(null);
	useEffect(() => {
		if (!isOnClick) return;
		const handleClickOutside = (e) => {
			if (rootRef.current && !rootRef.current.contains(e.target)) {
				setOpen(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, [isOnClick]);
	const toggle = () => {
		if (isOnClick) setOpen((prev) => !prev);
	};
	const tooltipStyle = {
		backdropFilter: 'blur(20px)'
	};
	return (
		<div
			ref={rootRef}
			className={`relative block ${!isOnClick ? 'group' : ''} ${wrapperClassName}`}
			onClick={isOnClick ? toggle : undefined}
		>
			{/* Trigger button */}
			<span className="inline-flex w-full">{children}</span>
			{/* Tooltip content */}
			<div
				role="tooltip"
				// Apply the backdrop-filter via the style prop
				style={tooltipStyle}
				// Tailwind classes for positioning and transition
				className={`absolute w-[200px] bottom-full left-1/2 z-20 mb-3 -translate-x-1/2 rounded-md bg-[#87868B] text-white text-center py-2 px-4 text-xs font-medium transition-opacity duration-300
    ${
			isOnClick
				? open
					? 'opacity-100 visible'
					: 'opacity-0 invisible'
				: 'opacity-0 invisible group-hover:opacity-100 group-hover:visible'
		}`}
			>
				{/* Tooltip pointer/arrow */}
				<span
					className={`absolute backdrop-blur-md -bottom-1.5 left-1/2 -z-10 h-3 w-3 -translate-x-1/2 rotate-45 bg-[#87868B]`}
				></span>
				{content}
			</div>
		</div>
	);
};
export default Tooltip;
